import flatpickr from "flatpickr";
import {format} from "small-date";
import {Order} from "../js/order/classes/Order";
import {PageInfos} from "../js/order/classes/PageInfos";
import {ProductItem} from "../js/order/classes/ProductItem";
import {Overview, INSTANTIATE_OVERVIEW} from "../js/order/classes/Overview";
import {INSTANTIATE_NAV_CART_BUTTON, NavCartButton} from "../js/order/classes/NavCartButton";
import {INSTANTIATE_PRODUCT_SELECT_SECTION} from "../js/order/classes/Sections/ProductSelect";
import {INSTANTIATE_PRODUCT_CONFIG_SECTIONS} from "../js/order/classes/Sections/ProductConfig";
import {CartSection, INSTANTIATE_CART_SECTION} from "../js/order/classes/Sections/Cart";
import {Section} from "../js/order/classes/Sections/Section";
import {INSTANTIATE_PAYMENT_SECTION} from "../js/order/classes/Sections/Payment";
import {INSTANTIATE_SHIPPING_SECTION, ShippingSection} from "../js/order/classes/Sections/Shipping";
import {Modal} from "bootstrap";
import {AddressSection, INSTANTIATE_ADDRESS_SECTION} from "../js/order/classes/Sections/Address";
import {ConfirmSection, INSTANTIATE_CONFIRM_SECTION} from "../js/order/classes/Sections/Confirm";
import {FinishSection, INSTANTIATE_FINISH_SECTION} from "../js/order/classes/Sections/Finish";

const BODY = document.querySelector('body');
const LOGGED_IN = !!document.querySelector('[data-status]');
const DELETE_AND_BACK_BUTTON = document.querySelector('[data-button="order-delete-and-back"]');

new Order(LOGGED_IN);
const ORDER_PRODUCTS = Order.products;
const SHIPPING_INFOS = Order.shipping;
const ADDRESS_INFOS = Order.address;
const CURRENT_STEP = Order.positionId;

const HAS_PRODUCTS = ORDER_PRODUCTS.length > 0;
const HAS_SHIPPING = Object.keys(SHIPPING_INFOS).length > 0 && SHIPPING_INFOS.constructor === Object;
const HAS_ADDRESS = Object.keys(ADDRESS_INFOS).length > 0 && ADDRESS_INFOS.constructor === Object;

const NAVBAR_DROPDOWN = document.querySelector('.navbar-dropdown') || false;

const INIT_NAVBAR_DROPDOWN = () => {
  if (NAVBAR_DROPDOWN) {
    const NAVBAR_DROPDOWN_TOGGLE = NAVBAR_DROPDOWN.querySelector('.navbar-dropdown-toggle') || false;
    const NAVBAR_DROPDOWN_MENU = NAVBAR_DROPDOWN.querySelector('.navbar-dropdown-menu') || false;
    const NAVBAR_DROPDOWN_BACK_LINK = NAVBAR_DROPDOWN.querySelector('.navbar-dropdown-back-link') || false;

    if (!NAVBAR_DROPDOWN_TOGGLE || !NAVBAR_DROPDOWN_MENU) return;

    document.body.addEventListener('click', e => {
      const IS_BACK_CLICK = e.composedPath().includes(NAVBAR_DROPDOWN_BACK_LINK);
      const IS_TOGGLE_CLICK = e.composedPath().includes(NAVBAR_DROPDOWN_TOGGLE);

      if (!IS_BACK_CLICK && !IS_TOGGLE_CLICK) NAVBAR_DROPDOWN_MENU.setAttribute('data-active', 'false');
    })

    NAVBAR_DROPDOWN_TOGGLE.addEventListener('click', () => {
      NAVBAR_DROPDOWN_MENU.setAttribute('data-active', `${NAVBAR_DROPDOWN_MENU.getAttribute('data-active') !== 'true'}`);
    })

  }
}

INIT_NAVBAR_DROPDOWN();

function HANDLE_TOTAL_CART_PRICE(OVERVIEW, CONFIG_SECTIONS, CONFIG_SECTION) {

  CartSection.updateCart();
  Section.showSectionById('cart');
  OVERVIEW.setCurrentStep('cart');
  NavCartButton.activate();
  CONFIG_SECTIONS.forEach(productSection => productSection.activateConfigButtons());

  const PRICE_DATA = ProductItem.getProductPrice(CONFIG_SECTION.id, CONFIG_SECTION.defaultFormObject);
  CONFIG_SECTION.setConfigPrice(PRICE_DATA.priceTotal)
}

/**
 * GET PAGE INFOS BEFORE EVERYTHING LOADS
 */
PageInfos.getInfos(LOGGED_IN).then(PAGE_INFOS => {
  BODY.classList.add('ready');

  const PRODUCT_PAGE_INFOS = PAGE_INFOS.productPageInfos;
  const SHIPPING_VALUES = PAGE_INFOS.shippingInfos;

  /**
   * INSTANTIATE CLASSES
   */
  const SELECT_SECTION = INSTANTIATE_PRODUCT_SELECT_SECTION();
  const PRODUCT_CONFIG_SECTIONS = INSTANTIATE_PRODUCT_CONFIG_SECTIONS(PRODUCT_PAGE_INFOS);
  const OVERVIEW = INSTANTIATE_OVERVIEW();
  const NAV_CART_BUTTON = INSTANTIATE_NAV_CART_BUTTON();
  const CART_SECTION = INSTANTIATE_CART_SECTION();
  const SHIPPING_SECTION = INSTANTIATE_SHIPPING_SECTION(SHIPPING_VALUES);
  const PAYMENT_SECTION = INSTANTIATE_PAYMENT_SECTION();
  const ADDRESS_SECTION = INSTANTIATE_ADDRESS_SECTION();
  const CONFIRM_SECTION = INSTANTIATE_CONFIRM_SECTION();
  INSTANTIATE_FINISH_SECTION(LOGGED_IN);

  /** SET SHIPPING EVENT-LISTENERS */
  if (SHIPPING_SECTION) {
    const FORM_ELEMENT = SHIPPING_SECTION.formElement;
    const FORM_FIELDS = Array.from(FORM_ELEMENT.elements);
    const TOGGLED_BY_ELEMENTS = Array.from(FORM_ELEMENT.querySelectorAll('[data-toggled-by]'));
    const FINISH_TEXT_FIELDS = Array.from(document.querySelectorAll('[data-finish-text][data-toggled-by]'));

    const FILTERED_TOGGLE_BY_ELEMENTS = TOGGLED_BY_ELEMENTS.filter(element => {
      return !element.getAttribute('data-toggled-by').includes('big') && !element.getAttribute('data-toggled-by').includes('small')
    })

    const ALL_TOGGLE_ELEMENTS = FILTERED_TOGGLE_BY_ELEMENTS.concat(FINISH_TEXT_FIELDS);


    FORM_FIELDS.forEach(formElement => {
      formElement.addEventListener('change', () => {
        const TOGGLE_KEY = formElement.getAttribute('data-toggle');
        const SPECIAL_TOGGLE = ShippingSection.element.querySelector('[data-special-toggle]');
        if (TOGGLE_KEY) ALL_TOGGLE_ELEMENTS.forEach(toggleElement => {
          if (toggleElement.getAttribute('data-toggled-by').includes(TOGGLE_KEY)) {
            toggleElement.classList.remove('d-none');
          } else toggleElement.classList.add('d-none');
        });

        if (formElement.name === 'packageStamp') {
          const SPECIAL_TOGGLE_VALUES = SPECIAL_TOGGLE.getAttribute('data-special-toggle').split(',')

          if (SPECIAL_TOGGLE_VALUES.includes(formElement.value)) {
            SPECIAL_TOGGLE.classList.remove('d-none');

          } else SPECIAL_TOGGLE.classList.add('d-none');
        }
      });

      ['change', 'blur'].forEach(listenerName => {
        formElement.addEventListener(listenerName, () => {

          const VALUE_INT = parseInt(formElement.value);
          const MIN_INT = formElement.min ? parseInt(formElement.min) : false;
          const MAX_INT = formElement.max ? parseInt(formElement.max) : false;

          if (MIN_INT && (formElement.value === '' || VALUE_INT < MIN_INT)) formElement.value = MIN_INT;
          if (MAX_INT && (VALUE_INT > MAX_INT)) formElement.value = MAX_INT;
        })
      })
    });
  }

  /** SET ADDRESS EVENT-LISTENERS */
  if (ADDRESS_SECTION) {
    const FORM_ELEMENT = ADDRESS_SECTION.formElement;
    const SHIPPING_ADDRESS_TOGGLE = FORM_ELEMENT.querySelector('[data-toggle="differ"]')
    const SHIPPING_ADDRESS_SECTION = FORM_ELEMENT.querySelector('[data-toggled-by="differ"]');
    const SHIPPING_ADDRESS_FORM_ELEMENTS = SHIPPING_ADDRESS_SECTION.querySelectorAll('[data-required="toggle"]');

    SHIPPING_ADDRESS_TOGGLE.addEventListener('change', () => {
      if (SHIPPING_ADDRESS_TOGGLE.checked) {
        SHIPPING_ADDRESS_SECTION.classList.remove('d-none')
        SHIPPING_ADDRESS_FORM_ELEMENTS.forEach(formElement => formElement.setAttribute('required', 'true'));
      } else {
        SHIPPING_ADDRESS_SECTION.classList.add('d-none');
        SHIPPING_ADDRESS_FORM_ELEMENTS.forEach(formElement => {
          formElement.removeAttribute('required');
          formElement.value = '';
        });
      }

    });
  }

  /** HANDLE PRODUCTS */
  if (HAS_PRODUCTS) {

    /** CALC CART PRICE AFTER HANDLE_ORDER_PRODUCTS AND ACTIVATE CART SECTION */
    ORDER_PRODUCTS.forEach(PRODUCT => {
      const CONFIG_SECTION = PRODUCT_CONFIG_SECTIONS.find(section => section.id === PRODUCT.pageInfos.productId);
      const CART_ITEM = new ProductItem(CONFIG_SECTION, PRODUCT.pageInfos, PRODUCT.formDataObject, PRODUCT.uuid);

      Order.updateOrderWithProduct(CART_ITEM);
    });

    CartSection.placeCartItems();
    CartSection.updateCart();
    ShippingSection.updateSectionElements();
    NavCartButton.activate();
    OVERVIEW.activateStepById('cart')
    OVERVIEW.activateStepById('shipping');
  }

  /** HANDLE SHIPPING */
  let savedDayString = false;
  if (HAS_SHIPPING) {
    OVERVIEW.activateStepById('address');
    ShippingSection.updateFormFields();
    savedDayString = SHIPPING_INFOS.packageDate;
  }

  /** HANDLE ADDRESS */
  if (HAS_ADDRESS) {
    AddressSection.updateFormFields();

    if (HAS_PRODUCTS && HAS_SHIPPING) {
      OVERVIEW.activateStepById('confirm');
      ConfirmSection.update();
      FinishSection.update();
    }
  }

  /** INIT DATE PICKER */
  const DATE_PICKER_FIELD = document.querySelector('[data-date]');
  if (DATE_PICKER_FIELD) {
    let incrementDay = 3;
    const DEFAULT_DATE_DAY = format(new Date().fp_incr(incrementDay), 'DDD');

    if (DEFAULT_DATE_DAY.toString().includes('Saturday') || DEFAULT_DATE_DAY.toString().includes('Samstag')) incrementDay = 5;
    else if (DEFAULT_DATE_DAY.toString().includes('Sunday') || DEFAULT_DATE_DAY.toString().includes('Sonntag')) incrementDay = 4;

    if (savedDayString) {
      const [day, month, year] = savedDayString.split(".");
      savedDayString = new Date(year, month - 1, day);
    }

    const PRESELECT_DAY = new Date().fp_incr(incrementDay);
    const DEFAULT_DATE = savedDayString && savedDayString.getTime() > PRESELECT_DAY.getTime() ? savedDayString : PRESELECT_DAY;
    const DATE_PICKER = DATE_PICKER_FIELD ? flatpickr(DATE_PICKER_FIELD, {
      defaultDate: DEFAULT_DATE,
      minDate: new Date().fp_incr(incrementDay),
      dateFormat: "d.m.Y",
      disable: [
        function (date) {
          return (date.getDay() === 0 || date.getDay() === 6);
        }
      ],
      locale: {
        "firstDayOfWeek": 1
      }
    }) : false;

    DATE_PICKER.input.value = format(DEFAULT_DATE, 'dd.MM.yyyy');
  }

  /** TOGGLE SECTION BASED ON SAVED DATA */
  if (HAS_PRODUCTS) {
    OVERVIEW.setCurrentStep(CURRENT_STEP);
    Section.showSectionById(CURRENT_STEP);
  } else {
    OVERVIEW.setCurrentStep('product-select');
    Section.showSectionById('product-select');
  }

  /** PRODUCT SELECT SECTION LOGIC */
  if (SELECT_SECTION) {
    SELECT_SECTION.productSelectButton.addEventListener('click', () => {
      const ACTIVE_INSTANCE = SELECT_SECTION.activeSelectionInstance;
      const CURRENT_CONFIG = PRODUCT_CONFIG_SECTIONS.find(configSection => configSection.id === ACTIVE_INSTANCE.id);
      const PRICE_DATA = ProductItem.getProductPrice(CURRENT_CONFIG.id, CURRENT_CONFIG.defaultFormObject);

      CURRENT_CONFIG.setConfigPrice(PRICE_DATA.priceTotal);
      CURRENT_CONFIG.activateConfigButtons();
      CURRENT_CONFIG.showSection();
    });
  }

  /** PRODUCT CONFIG SECTIONS LOGIC */
  PRODUCT_CONFIG_SECTIONS.forEach(CONFIG_SECTION => {
    const FORM_ELEMENTS_ARRAY = Array.from(CONFIG_SECTION.formElement.elements);
    const TOGGLE_ELEMENTS = CONFIG_SECTION.element.querySelectorAll('[data-toggled-by]');
    const ACTIVATE_ELEMENTS = CONFIG_SECTION.element.querySelectorAll('[data-activated-by]');

    /** CALCULATE PRODUCT PRICE ON INPUT */
    FORM_ELEMENTS_ARRAY.forEach(formElement => {
      formElement.addEventListener('input', () => {

        if (formElement.getAttribute('data-has-max') === 'true') {
          const PARENT_ELEMENT = formElement.closest('div');
          const MAX_FIELD_HOLDER = PARENT_ELEMENT.querySelector('.form-max-field');
          const MAX_FIELD = MAX_FIELD_HOLDER ? PARENT_ELEMENT.querySelector('input') : false;
          if (!MAX_FIELD) return;

          if (formElement.value.includes('max')) {
            MAX_FIELD_HOLDER.setAttribute('data-active', 'true');
            MAX_FIELD_HOLDER.removeAttribute('disabled');
            MAX_FIELD.value = MAX_FIELD.min
            MAX_FIELD.focus();
          } else {
            MAX_FIELD_HOLDER.setAttribute('data-active', 'false');
            MAX_FIELD_HOLDER.setAttribute('disabled', 'true');
            MAX_FIELD.value = ''
          }
        }

        /** HANDLE PLEATED TOGGLE ELEMENTS */
        if (CONFIG_SECTION.id === 'order-product-pleated' && formElement.hasAttribute('data-toggle')) {
          formElement.addEventListener('change', () => {
            const TOGGLE_KEY = formElement.getAttribute('data-toggle');

            TOGGLE_ELEMENTS.forEach(toggleElement => {
              if (toggleElement.getAttribute('data-toggled-by').includes(TOGGLE_KEY)) {
                toggleElement.classList.remove('d-none');
              } else toggleElement.classList.add('d-none');
            });

            ACTIVATE_ELEMENTS.forEach(activateElement => {
              if (activateElement.getAttribute('data-activated-by').includes(TOGGLE_KEY)) {
                activateElement.classList.remove('disabled');
              } else activateElement.classList.add('disabled');
            });
          });
        }

        if (formElement.getAttribute('data-check-group')) {
          const CHECK_GROUP = formElement.getAttribute('data-check-group');
          const CHECK_GROUP_FIELDS = CONFIG_SECTION.formElement.querySelectorAll(`[data-check-group="${CHECK_GROUP}"]`);
          const SIBLING_FIELDS = Array.from(CHECK_GROUP_FIELDS).filter(field => field !== formElement);
          SIBLING_FIELDS.forEach(field => field.checked = false);
        }

        const PRICE_DATA = ProductItem.getProductPrice(CONFIG_SECTION.id, CONFIG_SECTION.formDataObject);
        CONFIG_SECTION.setConfigPrice(PRICE_DATA.priceTotal)
      });

      if (formElement.type === 'number') formElement.addEventListener('change', () => {
        if (formElement.value !== '' && formElement.value !== '0') return;
        formElement.value = 1
      });

      ['change', 'blur'].forEach(listenerName => {
        formElement.addEventListener(listenerName, () => {
          const VALUE_INT = parseInt(formElement.value);
          const MIN_INT = parseInt(formElement.min);
          const MAX_INT = formElement.max ? parseInt(formElement.max) : false;

          if (MIN_INT && (formElement.value === '' || VALUE_INT < MIN_INT)) formElement.value = MIN_INT;
          if (MAX_INT && (VALUE_INT > MAX_INT)) formElement.value = MAX_INT;

          const PRICE_DATA = ProductItem.getProductPrice(CONFIG_SECTION.id, CONFIG_SECTION.formDataObject);
          CONFIG_SECTION.setConfigPrice(PRICE_DATA.priceTotal)
        })
      })
    });

    /** OVERWRITE PRODUCT */
    if (CONFIG_SECTION.overwriteButtonsElement) {
      CONFIG_SECTION.overwriteButtonsElement.addEventListener('click', () => {

        const SECTION_PAGE_INFOS = PageInfos.getProductPageInfoById(CONFIG_SECTION.id);
        const ARTICLE_UUID = CONFIG_SECTION.element.getAttribute('data-uuid');
        const CART_ITEM = new ProductItem(CONFIG_SECTION, SECTION_PAGE_INFOS, CONFIG_SECTION.formDataObject, ARTICLE_UUID);


        Order.updateOrderWithProduct(CART_ITEM);
        CONFIG_SECTION.element.removeAttribute('data-uuid');
        HANDLE_TOTAL_CART_PRICE(OVERVIEW, PRODUCT_CONFIG_SECTIONS, CONFIG_SECTION);
        CartSection.placeCartItems();
        ShippingSection.updateSectionElements();
        ConfirmSection.update();
        FinishSection.update();
      });
    }

    /** RETURN TO PRODUCT SELECT */
    if (CONFIG_SECTION.prevSectionButtonElement) {
      CONFIG_SECTION.prevSectionButtonElement.addEventListener('click', () => {
        Section.showSectionById('product-select');
        PRODUCT_CONFIG_SECTIONS.forEach(productSection => productSection.activateConfigButtons());

        const PRICE_DATA = ProductItem.getProductPrice(CONFIG_SECTION.id, CONFIG_SECTION.defaultFormObject);
        CONFIG_SECTION.setConfigPrice(PRICE_DATA.priceTotal)
      });
    }

    /** SAVE PRODUCT */
    if (CONFIG_SECTION.nextSectionButtonElement) {
      CONFIG_SECTION.nextSectionButtonElement.addEventListener('click', () => {

        const CURRENT_PAGE_INFOS = PageInfos.getProductPageInfoById(CONFIG_SECTION.id);
        const CART_ITEM = new ProductItem(CONFIG_SECTION, CURRENT_PAGE_INFOS, CONFIG_SECTION.formDataObject);

        Order.updateOrderWithProduct(CART_ITEM);
        HANDLE_TOTAL_CART_PRICE(OVERVIEW, PRODUCT_CONFIG_SECTIONS, CONFIG_SECTION);

        ShippingSection.updateSectionElements();
        ConfirmSection.update();
        FinishSection.update();
        CartSection.placeCartItems();
      });
    }
  })

  /** PRODUCT CART SECTION LOGIC */
  if (CART_SECTION) {
    CART_SECTION.addNewProductButton.addEventListener('click', () => {
      const SECTION_TO_ACTIVATE = 'product-select';
      Section.showSectionById(SECTION_TO_ACTIVATE);
      OVERVIEW.setCurrentStep(SECTION_TO_ACTIVATE);
    });

    CART_SECTION.nextSectionButton.addEventListener('click', () => {
      const SECTION_TO_ACTIVATE = 'shipping';
      Section.showSectionById(SECTION_TO_ACTIVATE);
      OVERVIEW.setCurrentStep(SECTION_TO_ACTIVATE);
    });
  }

  /** SHIPPING LOGIC */
  if (SHIPPING_SECTION) {
    SHIPPING_SECTION.previousSectionButton.addEventListener('click', () => {
      const SECTION_TO_ACTIVATE = 'cart';
      Section.showSectionById(SECTION_TO_ACTIVATE);
      OVERVIEW.setCurrentStep(SECTION_TO_ACTIVATE);
    });
    SHIPPING_SECTION.nextSectionButton.addEventListener('click', () => {
      const SECTION_TO_ACTIVATE = 'payment';
      const SHIPPING_DATA = ShippingSection.formDataObject;

      Order.updateShippingInfos(SHIPPING_DATA);
      Section.showSectionById(SECTION_TO_ACTIVATE);
      ConfirmSection.update();
      FinishSection.update();
      OVERVIEW.setCurrentStep('shipping');
    });
  }

  /** PAYMENT LOGIC */
  if (PAYMENT_SECTION) {
    PAYMENT_SECTION.previousSectionButton.addEventListener('click', () => {
      const SECTION_TO_ACTIVATE = 'shipping';
      Section.showSectionById(SECTION_TO_ACTIVATE);
      OVERVIEW.setCurrentStep(SECTION_TO_ACTIVATE);
    });
    PAYMENT_SECTION.nextSectionButton.addEventListener('click', () => {
      const SECTION_TO_ACTIVATE = 'address';

      Order.updatePaymentInfos(true);
      ConfirmSection.update();
      FinishSection.update();
      Section.showSectionById(SECTION_TO_ACTIVATE);
      OVERVIEW.setCurrentStep(SECTION_TO_ACTIVATE);

    });
  }

  /** ADDRESS LOGIC */
  if (ADDRESS_SECTION) {
    ADDRESS_SECTION.previousSectionButton.addEventListener('click', () => {
      Section.showSectionById('payment');
      OVERVIEW.setCurrentStep('shipping');
    });
    ADDRESS_SECTION.nextSectionButton.addEventListener('click', () => {
      const SECTION_TO_ACTIVATE = 'confirm';
      const VALID_FORM = AddressSection.validateFormFields();

      if (VALID_FORM) {
        Order.updateAddressInfos(AddressSection.formDataObject)
        ConfirmSection.update();
        FinishSection.update();
        Section.showSectionById(SECTION_TO_ACTIVATE);
        OVERVIEW.setCurrentStep(SECTION_TO_ACTIVATE);
      }
    });
  }

  /** CONFIRM LOGIC */
  if (CONFIRM_SECTION) {
    const EDIT_ADDRESS_BUTTON = CONFIRM_SECTION.element.querySelector('[data-button="edit-address"]');
    if (EDIT_ADDRESS_BUTTON) EDIT_ADDRESS_BUTTON.addEventListener('click', () => {
      AddressSection.updateFormFields();
      Section.showSectionById('address');
      OVERVIEW.setCurrentStep('address');
    });

    const EDIT_SHIPPING_BUTTON = CONFIRM_SECTION.element.querySelector('[data-button="edit-shipping"]');
    if (EDIT_SHIPPING_BUTTON) EDIT_SHIPPING_BUTTON.addEventListener('click', () => {
      ShippingSection.updateFormFields();
      Section.showSectionById('shipping');
      OVERVIEW.setCurrentStep('shipping');
    });

    CONFIRM_SECTION.nextSectionButton.addEventListener('click', () => {
      if (!ConfirmSection.confirmField.checkValidity()) {
        ConfirmSection.confirmField.reportValidity();
        ConfirmSection.confirmField.scrollIntoView({behavior: 'smooth', block: 'start'});
      } else {

        const SUBMIT_ACTION_ELEMENT = document.querySelector('[data-order-action]')
        const SUBMIT_ACTION = SUBMIT_ACTION_ELEMENT ? SUBMIT_ACTION_ELEMENT.getAttribute('data-order-action') : false;

        BODY.classList.remove('ready');
        PageInfos.getOrderInfos().then(ORDER_NUMBER_FETCH => {

          const ID_PREFIX = LOGGED_IN ? 'FH' : 'EK';
          const ID_YEAR = format(new Date(), 'yy');
          const ORDER_COUNT = ORDER_NUMBER_FETCH.orderNumbers.lastGivenOrderNumber;
          const COUNT_INT = parseInt(ORDER_COUNT) + 1;

          let ORDER_COUNT_PREFIX = '';

          if (COUNT_INT < 10) {
            ORDER_COUNT_PREFIX = '00000';
          } else if (COUNT_INT < 100) {
            ORDER_COUNT_PREFIX = '0000';
          } else if (COUNT_INT < 1000) {
            ORDER_COUNT_PREFIX = '000';
          } else if (COUNT_INT < 1000) {
            ORDER_COUNT_PREFIX = '00';
          } else if (COUNT_INT < 10000) {
            ORDER_COUNT_PREFIX = '0';
          }

          const ODER_ID = `${ID_PREFIX}${ID_YEAR}${ORDER_COUNT_PREFIX}${COUNT_INT}`;
          const ORDER_DATA = FinishSection.orderData(ODER_ID);

          /** CHECK IF ORDER DATA IS CORRECT */
          if (!ORDER_DATA) return;

          const JSON_DATA = JSON.stringify(ORDER_DATA);

          fetch(SUBMIT_ACTION, {
            headers: {
              Authorization: "Basic " + btoa('api@farnschlaeder.de' + ":" + 'RTU1jeu0yfp3xyk_mfw'),
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            method: "POST",
            body: JSON_DATA
          }).then(response => {
            return response.json()
          }).then(() => {
            BODY.classList.add('ready');

            FinishSection.updateFinishTextOrderId();
            Section.showSectionById('finish');
            Order.resetOrder();
            Overview.deactivateOverview();
            NavCartButton.deactivate();

          }).catch(error => console.log('error', error))
        })
      }
    });
  }

  /** DELETE DATA ON BUTTON CLICK LOGIC */
  if (DELETE_AND_BACK_BUTTON) DELETE_AND_BACK_BUTTON.addEventListener('click', () => Order.resetOrder());

  /** OVERVIEW LOGIC */
  if (OVERVIEW) {
    Overview.mobileButton.addEventListener('click', () => Overview.toggleOverviewBox());

    OVERVIEW.steps.forEach(step => {
      step.addEventListener('click', () => {
        if (step.getAttribute('data-active') !== 'true') return;
        const STEP_ID = step.getAttribute('data-step');
        Section.showSectionById(STEP_ID);
        OVERVIEW.setCurrentStep(STEP_ID);

        ShippingSection.updateFormFields();

        AddressSection.updateFormFields();
        ConfirmSection.update();
        FinishSection.update();

        PRODUCT_CONFIG_SECTIONS.forEach(productSection => {
          const PRODUCT_PRICE = ProductItem.getProductPrice(productSection.id, productSection.defaultFormObject);
          productSection.setConfigPrice(PRODUCT_PRICE.priceTotal);
          productSection.activateConfigButtons();
        });
      })
    });

    document.body.addEventListener('click', e => {
      const isClickedInsideParent = e.composedPath().includes(Overview.mobileButton);
      if (window.matchMedia("(max-width: 1200px)").matches) if (!isClickedInsideParent) Overview.deactivateOverviewBox();
    })

    window.addEventListener('resize', () => {
      if (window.matchMedia("(min-width: 1200px)").matches) Overview.deactivateOverviewBox();
    })
  }

  /** NAV-CART BUTTON LOGIC */
  NAV_CART_BUTTON.element.addEventListener('click', () => {
    Section.showSectionById('cart');
    OVERVIEW.setCurrentStep('cart');
    PRODUCT_CONFIG_SECTIONS.forEach(productSection => productSection.activateConfigButtons());
  })

  /** HANDLE CART_ITEM_DELETE */
  document.addEventListener('delete-cart-item', () => {
    ShippingSection.updateSectionElements();
    ConfirmSection.update();
    FinishSection.update();
  })

  /** PLEATED SPECIAL MODAL INFOS*/
  const modalInfoToggles = document.querySelectorAll('[data-modal-toggle][data-anchor-id]');
  modalInfoToggles.forEach(modalButton => modalButton.addEventListener('click', event => {
    event.preventDefault();

    const MODAL_ID = modalButton.getAttribute('data-modal-toggle');
    const ANCHOR_ID = modalButton.getAttribute('data-anchor-id');
    const MODAL_ELEMENT = MODAL_ID ? document.querySelector(`.modal#${MODAL_ID}`) : false;
    const MODAL_INSTANCE = MODAL_ELEMENT ? Modal.getOrCreateInstance(MODAL_ELEMENT) : false;

    if (!MODAL_INSTANCE) return;

    MODAL_INSTANCE.show();
    MODAL_ELEMENT.addEventListener('shown.bs.modal', () => {
      const ANCHOR_ELEMENT = document.querySelector(`#${ANCHOR_ID}`);
      if (ANCHOR_ELEMENT) {
        ANCHOR_ELEMENT.scrollIntoView({behavior: 'smooth', block: 'start'});
      }
    }, {once: true});
  }))


  ConfirmSection.update();
  FinishSection.update();
});
